import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const RevokeReenrollmentInviteMutation = graphql.persisted(
  "RevokeReenrollmentInvite",
  graphql(`
    mutation RevokeReenrollmentInvite($familyEnrollmentId: ID!) {
      revokeReenrollmentInvite(input: { familyEnrollmentId: $familyEnrollmentId }) {
        familyEnrollment { id state inviteStatus inviteToken queuedAt sentAt }
        userErrors { message path }
      }
    }
  `)
);

export { RevokeReenrollmentInviteMutation };

export function useRevokeReenrollmentInvite() {
  return useMutation(RevokeReenrollmentInviteMutation);
}
